@if (factSheetData$ | async; as factSheetData) {
  <div class="col-md-12 float-left p-2">
    <div class="col-md-3 p-0 float-left">
      <div>
        <label class="color-font font-text-600 mb-1">
          {{ 'factSheetHeader.labels.accountNumber' | cxTranslate }}
        </label>
        <p class="text-muted mb-2">{{ factSheetData?.header?.accountNumber }}</p>
      </div>
      <div>
        <label class="color-font font-text-600 mb-1">
          {{ 'factSheetHeader.labels.address' | cxTranslate }}
        </label>
        <p class="mb-3 text-muted mb-0">
          {{ factSheetData?.header?.accountName }} <br>
          {{ factSheetData?.header?.addressInfo?.line1 }} <br>
          {{ factSheetData?.header?.addressInfo?.town }} {{ formatState(factSheetData?.header?.addressInfo?.region?.isocode) }} {{ factSheetData?.header?.addressInfo?.postalCode }} <br>
          {{ factSheetData?.header?.addressInfo?.country?.name }}
        </p>
      </div>
      <div>
        <label class="color-font font-text-600 mb-1">
          {{ 'factSheetHeader.labels.accountPhone' | cxTranslate }}
        </label>
        <p class="mb-0 text-muted mb-0">
          {{ this.formatPhone(factSheetData?.header?.addressInfo?.phone) }}
        </p>
      </div>
    </div>
    @if (arrayToObject(factSheetData?.header?.emails?.entry); as entries) {
      <div class="col-md-3 p-0 float-left">
        <div class="col-md-12">
          <label class="color-font font-text-600 mb-1">
            {{ 'factSheetHeader.labels.orderEmail' | cxTranslate }}
          </label>
          @if (entries.hasOwnProperty('orderEmail')) {
            @if (splitEmails(entries['orderEmail']); as emails) {
              @if (emails.length > EMAILS_SHOW_LIMIT) {
                <div>
                  @if (!showAllOrderEmails) {
                    @for (email of emails.values; track email) {
                      <div class="text-muted mb-2">{{ email }}</div>
                    }
                  }
                  @if (showAllOrderEmails) {
                    @for (email of emails.values.slice(0,EMAILS_SHOW_LIMIT); track email) {
                      <div class="text-muted mb-2">{{ email }}</div>
                    }
                  }
                  @if (showAllOrderEmails) {
                    <a href="javascript: void(0)" (click)="showAllOrderEmails = !showAllOrderEmails">
                    {{ 'factSheetHeader.labels.showMore'| cxTranslate }}</a>
                  }
                  @if (!showAllOrderEmails) {
                    <a href="javascript: void(0)" (click)="showAllOrderEmails = !showAllOrderEmails">
                    {{'factSheetHeader.labels.hide'| cxTranslate }}</a>
                  }
                </div>
              }
              @if (emails.length <= EMAILS_SHOW_LIMIT && emails.length > 0) {
                <div>
                  @for (email of emails.values; track email) {
                    <div class="mb-1">{{ email }}</div>
                  }
                </div>
              }
              @if (emails.length === 0) {
                <div>
                  <div class="mb-1"></div>
                </div>
              }
            }
          } @else {
            <div class="mb-1"></div>
          }
        </div>
      </div>
    }
    @if (arrayToObject(factSheetData?.header?.emails?.entry); as entries) {
      <div class="col-md-3 p-0 float-left">
        <div class="col-md-12">
          <label class="color-font font-text-600 mb-1">
            {{ 'factSheetHeader.labels.invoiceEmail' | cxTranslate }}
          </label>
          @if (entries.hasOwnProperty('invoiceEmail')) {
            @if (splitEmails(entries['invoiceEmail']); as emails) {
              @if (emails.length > EMAILS_SHOW_LIMIT) {
                <div>
                  @if (!showAllInvoiceEmails) {
                    @for (email of emails.values; track email) {
                      <div class="text-muted mb-2">{{ email }}</div>
                    }
                  }
                  @if (showAllInvoiceEmails) {
                    @for (email of emails.values.slice(0,EMAILS_SHOW_LIMIT); track email) {
                      <div class="text-muted mb-2">{{ email }}
                      </div>
                    }
                  }
                  @if (showAllInvoiceEmails) {
                    <a href="javascript: void(0)" (click)="showAllInvoiceEmails = !showAllInvoiceEmails">
                    {{ 'factSheetHeader.labels.showMore' | cxTranslate }}</a>
                  }
                  @if (!showAllInvoiceEmails) {
                    <a href="javascript: void(0)" (click)="showAllInvoiceEmails = !showAllInvoiceEmails">
                    {{ 'factSheetHeader.labels.hide' | cxTranslate }}</a>
                  }
                </div>
              }
              @if (emails.length <= EMAILS_SHOW_LIMIT && emails.length > 0) {
                <div>
                  @for (email of emails.values; track email) {
                    <div class="text-muted mb-2">{{ email }}</div>
                  }
                </div>
              }
              @if (emails.length === 0) {
                <div>
                  <div class="mb-1"></div>
                </div>
              }
            }
          } @else {
            <div class="mb-1"></div>
          }
        </div>
      </div>
    }
  </div>
}

<ng-container>
  @if (brandList$ | async; as brands) {
    <div class="col-md-12 float-left p-0 pt-4 font-lg-size">
      @if (brands.length > 0 || (factSheetData$ | async); as factSheetData) {
        <div class="brands">
          <div class="mr-3 font-size-17 font-text-bold">{{ 'factSheetHeader.labels.viewPricesFor' | cxTranslate }}</div>
        </div>
      }
      <div class="sub-heading-brand">Select the respective brands to download the price book</div>
      <div class="d-flex brand-box-style">
        @for (key of sortBrands(brands); track key) {
          <div class="brand-box">
            <label >
              <input class="check-box" type="checkbox" (change)="onBrandChange(key, $event.target.checked)" [checked]="selectedBrands.includes(key)" />
              <div [innerHTML]="getImage(key)" class="brand-img" ></div>
            </label>
          </div>
        }
      </div>
      @if (selectedBrands.length) {
        <div class="sub-heading-category">Select the respective category</div>
        <div class="d-flex flex-wrap category-styles">
          @for (category of categories; track category) {
            <div>
              <label >
                <input type="checkbox" (change)="onCategoryChange(category, $event.target.checked)" [checked]="selectedCategories.includes(category)" />
                {{category}}
              </label>
            </div>
          }
        </div>
      }
      @if (selectedCategories.length) {
        <div class="d-flex justify-content-end">
          <a class="cx-link price-book-style" (click)="getPriceBookDetail()">View price book detail</a>
          <div class="float-right font-color-knbr-primary font-size font-text-600">
            <button class="font-color-knbr-primary download-links btn btn-outline-primary pt-3 download-link-btn" [disabled]="isDisabled" (click)="openCriteriaModal()">
              <i class="far fa-envelope pr-2 pl-2" aria-hidden="true"></i> {{ 'quoteCommon.label.emailMyPdf' | cxTranslate }}&nbsp;&nbsp;
            </button>
          </div>
        </div>
      }
      @if (selectedCategories.length && priceBookClicked) {
        <div ngbAccordion [closeOthers]="true" class="fact-sheet-accordion-styles">
          <div ngbAccordionItem [collapsed]="false" class="p-0">
            <div ngbAccordionHeader class="d-flex justify-content-between align-items-center px-3">
              <div class="pb-title">Price Book details</div>
              <button ngbAccordionButton class="btn btn-link d-flex justify-content-between p-3" (click)="buttonChange(this.buttonName)">
                <div class="buttonText">{{ this.buttonName }}</div>
              </button>
            </div>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  @if (factSheetData$ | async; as factSheetData) {
                    <div>
                      <div class="d-flex">
                        @for (item of selectedBrandNamesList; track item) {
                          <button class="btn btn-brand mr-2"
                            [ngClass]="(item.id === activeBrand || item.idCA === activeBrand) ? 'btn-selected' : ''"
                          (click)="brandChangeOnTable(item)">{{item.name}}</button>
                        }
                      </div>
                      <hr class="mt-0 ml-4">
                      @if (factSheetData?.priceSheetItems && factSheetData?.priceSheetItems.length) {
                        <div class="col-lg-12 p-0 d-flex justify-content-md-between"
                          >
                          <div class="p-0 mt-0 mb-2 font-text-400 font-md-size">
                            {{'factSheetMaterial.showingDetail' | cxTranslate : { current:
                            (factSheetData?.priceSheetItems?.length), total: factSheetData?.pagination?.totalResults } }}
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <cx-page-slot position="BottomContent"></cx-page-slot>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- <ngb-accordion #acc="ngbAccordion"  [closeOthers]="false" activeIds="panel-1">
      <ngb-panel  class="p-0" id="panel-1">
        <ng-template ngbPanelTitle>
          <span (click)="buttonChange(this.buttonName)">
            {{ this.buttonName }}
          </span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div *ngIf="factSheetData$ | async as factSheetData">
            <div class="d-flex">
              <button *ngFor="let item of selectedBrandNamesList" class="btn btn-brand mr-2" [ngClass]="(item.id === activeBrand || item.idCA === activeBrand) ? 'btn-selected' : ''" (click)="brandChangeOnTable(item)">{{item.name}}</button>
            </div>
            <hr class="mt-0 ml-4">
            <div class="col-lg-12 p-0 d-flex justify-content-md-between" *ngIf="factSheetData?.priceSheetItems && factSheetData?.priceSheetItems.length">
              <div class="p-0 mt-0 mb-2 font-text-400 font-md-size">
                {{'factSheetMaterial.showingDetail' | cxTranslate : { current: (factSheetData?.priceSheetItems?.length), total: factSheetData?.pagination?.totalResults } }}
              </div>
            </div>
          </div>
          <cx-page-slot position="BottomContent"></cx-page-slot>
        </ng-template>
      </ngb-panel>
    </ngb-accordion> -->
  </div>
}
</ng-container>


@if (downloadProgress) {
  <ng-container class="cx-spinner">
    <cx-spinner class="cx-dialog-popover-center-backdrop"></cx-spinner>
  </ng-container>
}
